import { formatDataValue } from 'utils/formatFns';
import { currencyFormatting } from 'utils/general';

export const pricingFields = {
  tsrp: {
    label: 'TSRP',
    getValue: (data) => data?.pricing?.dealerMSRP?.totalSuggestedRetailPrice,
    formatValue: (value) => {
      const formatted = currencyFormatting(parseFloat(value) || null);
      return formatDataValue({ value: formatted });
    },
  },
};
